var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":_vm.embeddedLink,"width":"100%","height":"500","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }